
const PrevIcon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9">
		<g id="Group_1131" data-name="Group 1131" transform="translate(-255 -775.5) rotate(180, 258, 780)">
			<g id="Group_876" data-name="Group 876" transform="translate(-354 1145.5) rotate(-90)">
				<path id="Path_717" data-name="Path 717" d="M4.5,2,9,8H0Z" transform="translate(370 617) rotate(180)"
					  fill="black"/>
			</g>
		</g>
	</svg>
);

export default PrevIcon;
